var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outstock-bar fade-in"},[_vm._v(" สินค้าหมดแล้ว ขออภัยในความไม่สะดวก ")])}
var staticRenderFns = []

export { render, staticRenderFns }